import script from "./SimuladorDeConsumo.vue?vue&type=script&setup=true&lang=js"
export * from "./SimuladorDeConsumo.vue?vue&type=script&setup=true&lang=js"

import "./SimuladorDeConsumo.vue?vue&type=style&index=0&id=161f6522&lang=postcss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-161f6522"]])

export default __exports__